export enum AdditionalProfileAdjustmentPath {
  Profile = 'profile/:profileCode',
  NewProfile = 'profile',
  Review = 'adjustment/:adjustmentId',
}
